import { DASHBOARD_ROLES } from "@/pages/home/components/role-dashboard/types/dashboard-role.types";
import { APP_ROUTES_TO } from "@/utils/routes";

import type { RoleSidebarPathsByRole } from "../types/sidebar-role.types";

const SETTING_AGENT_SIDEBAR_PATHS = [
    APP_ROUTES_TO.ROOT,
    APP_ROUTES_TO.CALLS,
    APP_ROUTES_TO.LISTS,
    APP_ROUTES_TO.PERFORMANCE_KPIS,
    // Still gated by the report permissions, so setters only see it with access to at least one report.
    APP_ROUTES_TO.PERFORMANCE_REPORTS,
    // Still gated by CALL_TELLI_MANAGE, so only setting team leads with it see Telli.
    APP_ROUTES_TO.DEVELOPER_TELLI,
] as const;

export const ROLE_SIDEBAR_PATHS: RoleSidebarPathsByRole = {
    [DASHBOARD_ROLES.SETTING_AGENT]: SETTING_AGENT_SIDEBAR_PATHS,
    [DASHBOARD_ROLES.SENIOR_SETTER]: SETTING_AGENT_SIDEBAR_PATHS,
    [DASHBOARD_ROLES.CSO]: [
        APP_ROUTES_TO.ROOT,
        APP_ROUTES_TO.CALLS,
        APP_ROUTES_TO.PERFORMANCE_KPIS,
        APP_ROUTES_TO.PERFORMANCE_REPORTS,
    ],
    [DASHBOARD_ROLES.CMO]: [
        APP_ROUTES_TO.ROOT,
        APP_ROUTES_TO.CALLS,
        APP_ROUTES_TO.PERFORMANCE_KPIS,
        APP_ROUTES_TO.PERFORMANCE_REPORTS,
    ],
};
